// extracted by mini-css-extract-plugin
export default {"send_button":"ChatForm_send_button__EGc4Y"};